"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_client_1 = require("apollo-client");
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const apollo_link_http_1 = require("apollo-link-http");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const constants_1 = require("../constants");
const queries_1 = require("./queries");
const parsePool = (_a) => {
    var { decimals, allocPoint, lastRewardBlock, userCount, updatedAt } = _a, rest = __rest(_a, ["decimals", "allocPoint", "lastRewardBlock", "userCount", "updatedAt"]);
    return (Object.assign({ decimals: +decimals, allocPoint: +allocPoint, lastRewardBlock: +lastRewardBlock, userCount: +userCount, updatedAt: +updatedAt }, rest));
};
const parseStakingInfo = (_a) => {
    var { startBlock, endBlock, totalAllocPoint, poolCount, pools } = _a, rest = __rest(_a, ["startBlock", "endBlock", "totalAllocPoint", "poolCount", "pools"]);
    return (Object.assign({ startBlock: +startBlock, endBlock: +endBlock, totalAllocPoint: +totalAllocPoint, poolCount: +poolCount, pools: pools.map(parsePool) }, rest));
};
class IndexedStakingSubgraphClient {
    constructor(client) {
        this.client = client;
    }
    static forNetwork(network) {
        const client = new apollo_client_1.ApolloClient({
            link: new apollo_link_http_1.HttpLink({ uri: constants_1.SUBGRAPH_URLS[network].indexedStaking, fetch: isomorphic_fetch_1.default }),
            cache: new apollo_cache_inmemory_1.InMemoryCache(),
            shouldBatch: true,
        });
        return new IndexedStakingSubgraphClient(client);
    }
    getStakingInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.query({
                query: queries_1.ALL_STAKING_INFO,
                fetchPolicy: 'cache-first'
            }).then((result) => parseStakingInfo(result.data.multiTokenStakings[0]));
        });
    }
}
exports.default = IndexedStakingSubgraphClient;
